// ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseInfoConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  get MESSAGE() {
    return {
      MG01a: localizer.getText('LICENSE_CHECKER_MESSAGE_CONFIRM_CHANGE_TO_OFFLINE'),
      MG01b: localizer.getText('LICENSE_CHECKER_MESSAGE_CONFIRM_CHANGE_TO_ONLINE'),
      MG03: localizer.getText('LICENSE_CHECKER_MESSAGE_LICENSE_KEY_INVALID'),
      MG04: localizer.getText('LICENSE_CHECKER_MESSAGE_TOKEN_INVALID'),
      MG05: localizer.getText('LICENSE_CHECKER_MESSAGE_DAYS_TILL_EXPIRED'),
      MG05a: localizer.getText('LICENSE_CHECKER_MESSAGE_DAYS_EXPIRED'),
      MG05b: localizer.getText('LICENSE_CHECKER_MESSAGE_EXPIRED'),
      MG06: localizer.getText('LICENSE_CHECKER_MESSAGE_NEW_LICENSE_OR_TOKEN_INVALID'),
      MG07a: localizer.getText('LICENSE_CHECKER_MESSAGE_VALIDATE_ON_OR_AFTER'),
      MG08: localizer.getText('LICENSE_CHECKER_MESSAGE_TOKEN_REQUIRED'),
      MG09: localizer.getText('LICENSE_CHECKER_MESSAGE_LICENSE_KEY_REQUIRED'),
      MG10: localizer.getText('LICENSE_CHECKER_MESSAGE_LICENSE_NO_LONGER_VALID'),
      MG11: localizer.getText('LICENSE_CHECKER_MESSAGE_NEW_LICENSE_INVALID'),
      CANNOT_REACH_LICENSE_SERVER: localizer.getText('LICENSE_CHECKER_MESSAGE_LOST_CONNECTION_TO_LICENSE_SERVER')
    };
  },
  get Description() {
    return localizer.getText('LICENSE_CHECKER_MESSAGE_ENTER_LICENSE_DESCRIPTION');
  },
  LICENSE_KEY_CONSTRAINT: {
    presence: {
      presence: true,
      get message() {
        return localizer.getText('LICENSE_CHECKER_MESSAGE_LICENSE_KEY_CONSTRAINT');
      }
    }
  },
  TOKEN_CONSTRAINT: {
    presence: {
      presence: true,
      get message() {
        return localizer.getText('LICENSE_CHECKER_MESSAGE_TOKEN_CONSTRAINT');
      }
    }
  },
  MAP_MODULES_NAME: 'Maps',
  LICENSE_NOTIFICATION_MESSAGE_KEY: {
    NO_LONGER_VALID: 'noLongerValid',
    VALID_IN_ALLOW_PERIOD: 'validInAllowPeriod'
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.LicenseInfoConstants.js